import { Row } from "../../../../core/components/Row";
import { Facebook2Icon } from "../../../../core/icons/Facebook";
import { Instagram2Icon } from "../../../../core/icons/Instagram";
import { TikTok2Icon } from "../../../../core/icons/Tiktok";

export const SocialLinks = ({ className, classNameIcon }: { className?: string; classNameIcon?: string }) => {
	const Link: React.FC<{ href: string; ariaLabel: string; IconComponent: React.ReactNode }> = ({ href, ariaLabel, IconComponent }) => {
		return (
			<a
				href={href}
				target="_blank"
				rel="noreferrer"
				aria-label={ariaLabel}
				className="flex p-3 cursor-pointer rounded-full justify-center items-center bg-white hover:opacity-80 hover:bg-primaryTangerine hover:text-white transition-all duration-300 ease-in-out"
			>
				{IconComponent}
			</a>
		);
	};
	return (
		<Row className={`gap-2 max-lg:justify-center text-primarySunset ${className}`}>
			<Link
				href="https://www.facebook.com/weddingplannertacna"
				ariaLabel="Red Social de Facebook"
				IconComponent={<Facebook2Icon className={classNameIcon} />}
			/>
			<Link
				href="https://www.instagram.com/megabodas_wedding_planner/"
				ariaLabel="Red Social de Instagram"
				IconComponent={<Instagram2Icon className={classNameIcon} />}
			/>
			<Link
				href="https://www.tiktok.com/@megabodas_weddingplanner"
				ariaLabel="Red Social de TikTok"
				IconComponent={<TikTok2Icon className={classNameIcon} />}
			/>
		</Row>
	);
};
